export default class Collapse {
    static init(): void {
        this.toggle();
    }

    static toggle(): void {
        const toggles = document.querySelectorAll('[data-toggle="collapse"][data-target]');

        toggles.forEach((toggle) => {
            toggle.addEventListener('click', (e) => {
                e.preventDefault();
                const dataTarget = toggle.getAttribute('data-target');
                if (!dataTarget) return;
                const target = document.getElementById(dataTarget);
                if (!target) return;

                if (target.classList.contains('collapse--show')) {
                    target.classList.remove('collapse--show');
                    toggle.setAttribute('data-aria-expanded', 'false')
                } else {
                    target.classList.add('collapse--show');
                    toggle.setAttribute('data-aria-expanded', 'true')
                }

            });
        });
    }

}
